import styled from 'styled-components';

import { gray40 } from 'lib/colors';

export default styled.div`
  height: 1px;
  width: 100%;
  background-color: ${gray40};
`;
